import { Alert } from "../components";
import { useCheckoutGate } from "../hooks";

const CheckoutGateAlert = ({ className }: { className?: string }) => {
  const { hoursMessage, belowMinimum, minOrderMessage } = useCheckoutGate();
  if (hoursMessage)
    return <Alert type="warning" className={className} message={hoursMessage} />;
  if (belowMinimum)
    return (
      <Alert
        showIcon
        type="warning"
        className={className}
        message={minOrderMessage}
      />
    );
  return null;
};

export default CheckoutGateAlert;
